/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-await-in-loop */
/* eslint-disable dot-notation */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable class-methods-use-this */
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import Auth from '../../utils/Auth';
import { getBackendId } from '../../constants/apiEnv';
import { validFileName, allValidFileExtensions, getS3Region } from '../../utils/helpers';

class S3Uploads {
/*
* Upload files to S3 bucket
*/

async getAwsConfig(getErrorAlert) {
    return new Promise(function (resolve, reject) {
        AWS.config.getCredentials(async function (err) {
            if (err) {
                if (getErrorAlert) {
                    getErrorAlert(true);
                }
                toast.error(err && err.message);
                return reject(err);
            }
            return resolve(AWS.config.credentials);
        });
    });
}

async s3uploadFile(s3, params, getErrorAlert) {
    return new Promise((resolve, reject) => {
        s3.putObject(params, async function (err, data) {
            if (err) {
                if (getErrorAlert) {
                    getErrorAlert(true);
                }
                toast.error(err && err.message);
                return reject(err);
            } return resolve(data);
        });
    });
}

PublicUpload = async (files, fileIds, installation, airportCode, entity, publicFolder, getErrorAlert) => {
    files?.forEach((file) => {
        const fileformat = file?.name?.split('.')?.pop();
        if (!allValidFileExtensions?.includes(fileformat?.toLowerCase())) {
            toast.error('File format not supported');
            return null;
        }
    });
    AWS.config.update({
        region: process.env.REACT_APP_REGION,
        credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
        })
    });
    let response = [];
    const getError = typeof getErrorAlert === 'function';
    const credentials = await this.getAwsConfig(getError && getErrorAlert);
    if (credentials) {
        const s3 = new AWS.S3({
            apiVersion: '2006-03-01',
            accessKeyId: AWS.config.credentials.accessKeyId,
            secretAccessKey: AWS.config.credentials.secretAccessKey,
            sessionToken: AWS.config.credentials.sessionToken,
            region: getS3Region()
        });
        for (let index = 0; index < files.length; index++) {
            let fileName = `public/${publicFolder}/${installation}/${airportCode}/${fileIds?.[index]}`;
            let file = {};
            let fileSize = this.getAeroFileSize(files[index].size);

            const params = {
                Bucket: `${process.env.REACT_APP_S3PREFIX}${installation}-uploads`,
                Key: fileName,
                Body: files[index],
                ContentType: files[index].type,
                Metadata: {
                    'name': validFileName(files?.[index].name),
                    'size': files?.[index].size?.toString(),
                    'id': fileIds?.[index],
                    'entity': entity
                }
            };
            const up = await this.s3uploadFile(s3, params, getErrorAlert);
            if (up) {
                file['name'] = validFileName(files[index].name);
                file['size'] = fileSize;
                file['entity'] = entity;
                file['id'] = fileIds[index];
                response.push(file);
            }
        }
        return response;
    } return response;
}

uploadFiles = async (files, fileIds, entity, id, airportCode, getErrorAlert) => {
    let isValidFile = true;
    files.forEach((file) => {
        const fileformat = file?.name?.split('.')?.pop();
        if (!allValidFileExtensions?.includes(fileformat?.toLowerCase())) {
            toast.error('File format not supported');
            isValidFile = false;
        }
    });
    if (!isValidFile) return null;
if (entity === 'hazard') {
    await this.PublicUpload(files, fileIds, id, airportCode, entity, 'safety_management', getErrorAlert);
} else if (entity === 'badging') {
    await this.PublicUpload(files, fileIds, id, airportCode, entity, 'badging', getErrorAlert);
} else if (entity === 'forms') {
    await this.PublicUpload(files, fileIds, id, airportCode, entity, 'forms', getErrorAlert);
} else if (entity === 'noise_log') {
    await this.PublicUpload(files, fileIds, id, airportCode, entity, 'noise_log', getErrorAlert);
} else if (entity === 'lease_workorder') {
    await this.PublicUpload(files, fileIds, id, airportCode, entity, 'non_airfield', getErrorAlert);
} else if (entity === 'adp') {
    return this.PublicUpload(files, fileIds, id, airportCode, entity, 'driver_permit', getErrorAlert);
} else if (entity === 'company_registration') {
    return this.PublicUpload(files, fileIds, id, airportCode, entity, 'company_registration', getErrorAlert);
} else if (entity === 'scheduling') {
    return this.PublicUpload(files, fileIds, id, airportCode, entity, 'scheduling', getErrorAlert);
} else {
    try {
        const sub = localStorage.getItem('userId');
        const getError = typeof getErrorAlert === 'function';
        Auth.updateAwsAuth();
        let response = [];
        const credentials = await this.getAwsConfig(getError && getErrorAlert);
        if (credentials) {
            const s3 = new AWS.S3({
                apiVersion: '2006-03-01',
                accessKeyId: AWS.config.credentials.accessKeyId,
                secretAccessKey: AWS.config.credentials.secretAccessKey,
                sessionToken: AWS.config.credentials.sessionToken,
                region: getS3Region()
            });
            for (let index = 0; index < files.length; index++) {
                let fileName = `private/${sub}/${fileIds[index]}`;
                let file = {};
                let fileSize = this.getAeroFileSize(files[index].size);
                const backendId = getBackendId();
                const params = {
                    Bucket: `${process.env.REACT_APP_S3PREFIX}${backendId}-uploads`,
                    Key: fileName,
                    Body: files[index],
                    ContentType: files[index].type,
                    Metadata: {
                        'name': validFileName(files[index].name),
                        'size': files[index].size.toString(),
                        'id': fileIds[index],
                        'entity': entity
                    }
                };
                const up = await this.s3uploadFile(s3, params, getError && getErrorAlert);
                if (up) {
                    file['name'] = validFileName(files[index].name);
                    file['size'] = fileSize;
                    file['entity'] = entity;
                    file['id'] = fileIds[index];
                    response.push(file);
                }
            }
            return response;
        }
        return response;
    } catch (err) {
        toast.error(err?.response?.data?.message || err?.message);
        return null;
    }
}
};

/*
* Get file size in KB or MB
*/
getAeroFileSize = (filesize) => {
    if (filesize > 1024) {
        return `${(filesize / 1024 / 1024).toFixed(2)} KB`;
    } return `${(filesize / 1024).toFixed(2)} KB`;
};
}

const Service = new S3Uploads();

export default Service;
export { Service as S3Uploads };
